module.exports = __webpack_public_path__ + "img/floor-layout-none.d89a1058.png";